<template class="d-flex align-items-center">
  <div>
      <loading :active="cargando" :is-full-page="true"></loading>
    <b-container class="bv-example-row" v-if="!cargando">
      <br><br><br><br>
      <b-row align-v="center">
        <b-col></b-col>
        <b-col>
            <div class="login">
              <div class="main">
                <div class="header"></div>
                <div class="content">

                  <label for="email">Usuario</label> <br>
                  <input id="email" type="text" v-model="email"> <br><br>
      
                  <label for="password">Contraseña</label> <br>
                  <input id="password" type="password" v-model="password" @keyup.enter="makeLogin">
                </div>
                  <br>
                <div class="buttons">
                  <b-button variant="primary" class="mr-3" @click="makeLogin">Ingresar</b-button>
                </div> <br>
                <div class="error" v-if="error">
                  {{ error }}
                </div>
              </div>
            </div>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { AuthService } from '@/services/auth.service'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      error: '',
      cargando: false
    }
  },
  components: {
    Loading
  },
  methods: {
    async makeLogin () {
      try {
        this.cargando = true
        await AuthService.makeLogin({ email: this.email, password: this.password })
        this.error = ''
        await this.$store.dispatch('user/getCurrent')
        await this.$store.dispatch('year/getList')
        await this.$store.dispatch('course/getList')
        this.$session.start()
        this.$router.push({ path: '/' })
      } catch (error) {
        this.cargando = false
        this.error = error.status === 404 ? 'User with same email not found' : error.message
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 75%;
  display: flex;
  justify-content: center;
  align-items: center;

  .main {
    padding: 30px 15px;
    background: #fff;
    width: 400px;
    border: 1px solid rgb(233, 233, 233);
    border-radius: 5px;

    .header {
      text-align: center;
    }
    input{
      border: 1px solid rgb(219, 219, 219);
      border-radius: 5px;
      width: 100%;;
      padding: 5px;
    }
    .recuperarContraseña{
      list-style: none;
      text-decoration: none;
      color: primary;
      border: none;
      &:hover{
        border: none;
        background-color:transparent;
        color: rgb(82, 82, 224);
      }
    }

    .error {
      background-color: red;
      padding: 10px;
      font-size: 12px;
      opacity: 1;
      transition: all 0.5s;
    }
  }
}
</style>
